import React from 'react';
import PropTypes from 'prop-types';
import Calendar from 'react-calendar';
import { DateTime } from 'luxon';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-solid-svg-icons';

import style from './EventCalendar.module.css';

const EventCalendar = ({ onChange, active, events }) => (
  <div className={style.calendar}>
    <Calendar
      minDetail="month"
      onChange={onChange}
      value={active ? DateTime.fromISO(active).toJSDate() : undefined}
      formatShortWeekday={(_, date) => DateTime.fromJSDate(date).toFormat('ccccc')}
      nextLabel={
        <FontAwesomeIcon
          icon={faChevronRight}
          size="lg"
          className="text-gray-600 hover:text-gray-200 transition-color"
          fixedWidth
        />
      }
      prevLabel={
        <FontAwesomeIcon
          icon={faChevronLeft}
          size="lg"
          className="text-gray-600 hover:text-gray-200 transition-color"
          fixedWidth
        />
      }
      next2Label={null}
      prev2Label={null}
      tileClassName={({ date }) => {
        const d = DateTime.fromJSDate(date).toISODate();
        const event = events.find((x) => x.date === d);
        return event ? 'react-calendar__tile--event' : 'pointer-events-none';
      }}
    />
  </div>
);

EventCalendar.propTypes = {
  active: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      date: PropTypes.string.isRequired,
    })
  ).isRequired,
};

EventCalendar.defaultProps = {
  active: '',
};

export default EventCalendar;
